import React, { Component } from 'react';
import axios from 'axios';
import _ from 'lodash';
import { API_URL } from '../../partials/Globals';
import Errors from '../../partials/Errors';
import Message from '../../partials/Message';
import Student from './Student';

export default class AddStudent extends Component {
    state = {
        errors: '',
        message: '',
        group: {
            name: ''
        },
        students: [],
        first_name: ''
    }

    constructor(props) {
        super(props);

        this.fetch = this.fetch.bind(this);
        this.submit = this.submit.bind(this);
        this.inputChange = this.inputChange.bind(this);
    }

    componentDidMount() {
        this.fetch();
    }

    fetch() {
        axios.get(API_URL+'/admin/groups/'+this.props.match.params.group_id)
            .then(response => {
                this.setState({ group: response.data });
                if (response.data.students && response.data.students.length > 0) {
                    var students = _.orderBy(response.data.students, ['created_at'], ['desc']);
                    this.setState({ students: students });
                }
            });
    }

    inputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({ [name]: value });
    }

    submit(event) {
        event.preventDefault();

        axios.post(API_URL+'/admin/students', {
            first_name: this.state.first_name,
            group_id: this.props.match.params.group_id
        })
        .then(response => {
            this.setState({ message: 'Användaren sparades.' }, () => {
                setTimeout(() => { this.setState({ message: '' }) }, 3000);
            });
            this.setState({
                first_name: ''
            });
            this.fetch();
        })
        .catch(error => {
            // Valideringsfel
            if (error.response && error.response.status === 422) {
                this.setState({ errors: error.response.data }); 
            }
            // Annat fel
            if (error.response && error.response.status === 400) {
                this.setState({ errors: {1: 'Någonting gick fel, var god försök igen.'} })
            }
        });
    }

    render() {
        const self = this;
        const { students, group } = this.state;
        
        return (
            <div>
                <div className="top">
                    <div className="col-12">
                        <button className="back" onClick={ this.props.history.goBack }>Tillbaka</button>
                    </div>
                </div>

                <Message message={ this.state.message } /> 
                <Errors errors={ this.state.errors } />

                <div className="container">
                    <div className="content">
                        <h1>Lägg till ny deltagare till { this.state.group.name }</h1>

                        <form onSubmit={ this.submit }>
                            <label>Namn</label>
                            <input type="text" name="first_name" placeholder="Namn" required value={ this.state.first_name } onChange={ this.inputChange } />

                            <input className="button purple" type="submit" value="Spara" />
                        </form>
            
                        <div className="block">
                            <div className="header">
                                <h4>Deltagare</h4>
                            </div>
                            <div className="body">
                                { (students && students.length > 0) ? (
                                    <ul className="has-icons">
                                        { Object.keys(students).map(function(key) {
                                            return (
                                                <Student key={ students[key].id } student={ students[key] } group_id={ group.id } update={ self.fetch } />
                                            )
                                        })}
                                    </ul>
                                ) : (
                                    <span>Det finns inga deltagare.</span>
                                ) }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/admin/Group/AddStudent.js